import { render } from "./MailIcon.vue?vue&type=template&id=63290872&scoped=true"
const script = {}

import "./MailIcon.vue?vue&type=style&index=0&id=63290872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63290872"]])

export default __exports__